import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SendSVG = function SendSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.971,4.565l-7.74,24.09a1.98,1.98,0,0,1-1.69,1.37,1.785,1.785,0,0,1-.23.02,1.978,1.978,0,0,1-1.72-1l-5.21-8.94,1.46-1.46,5.45-5.46a1,1,0,0,0-1.41-1.41l-6.86,6.86-9.19-6.12a2,2,0,0,1,.56-3.59l24.12-6.89a1.988,1.988,0,0,1,1.99.53A2.018,2.018,0,0,1,29.971,4.565Z"
  }));
};
SendSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SendSVG);